import React from 'react';

import type { Transaction } from 'types/api/transaction';

import type { StatusTagType } from './StatusTag';
import StatusTag from './StatusTag';

export interface Props {
  status: Transaction['status'];
  errorText?: string | null;
  isLoading?: boolean;
}

const TxStatus = ({ status, errorText, isLoading }: Props) => {
  if (status === undefined) {
    return null;
  }

  let text;
  let type: StatusTagType;

  switch (status) {
    case 'ok':
      text = 'Success';
      type = 'ok';
      break;
    case 'error':
      text = 'Failed';
      type = 'error';
      break;
    case null:
      text = 'Pending';
      type = 'pending';
      break;
  }

  return (
    <StatusTag
      type={ type }
      padding="2px 12px 2px 12px"
      color={ status === 'error' ? '#FF073A' : '#0BB44F' }
      text={ text }
      errorText={ errorText }
      isLoading={ isLoading }
      bg={
        status === 'error' ? 'rgba(255, 7, 58,0.08)' : 'rgba(11, 180, 79,0.08)'
      }
    />
  );
};

export default TxStatus;
